import $ from "jquery";

const buttonLeningberekening = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      button: ".js-leningberekening",
      targetToggleClass: ".js-ShowHideElement .SearchLoanTop",
      targetToggleDisplay: ".js-ShowHideElement #iframe-loan",
    };

    if ($(el.button).length === 0) return;

    $(document).on("click", el.button, function () {
      $(el.targetToggleClass).addClass("open");
      $(el.targetToggleDisplay).show();
    });
  };

  init();
};

try {
  buttonLeningberekening();
} catch (error) {
  console.error("buttonLeningberekening", error);
}
